import React, { ComponentProps, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import { PrimaryAction, SecondaryAction, TwitterButton } from './styles'
import AlertModal from '../../../components/AlertModal'
import useClearGameState from '../useClearGameState'
import useCheckGameEnd from '../useCheckGameEnd'
import GameContext from '../GameContext'
import Data from '../../../data.json'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTwitterSquare } from '@fortawesome/free-brands-svg-icons'
import { TwitterShareButton } from 'react-share'

type TwitterIntentProps = {
  text?: string
  url?: string
  hashtags?: string[]
} & Omit<ComponentProps<'a'>, 'href' | 'target' | 'rel'>

const GameWinMessage: React.FC = () => {
  const {
    difficulty,
    isShowingWinModal,
    setIsShowingWinModal,
    hoursText,
    minutesText,
    secondsText,
    setIsCheckWin,
  } = useContext(GameContext)

  const onClearGameState = useClearGameState()
  const history = useHistory()
  useCheckGameEnd()

  const onGoBack = (): void => {
    history.goBack()
  }

  const onPlayAgain = (): void => {
    setIsShowingWinModal(false)
    onClearGameState()
  }

  const onReCheckWin = (): void => {
    setIsCheckWin(true)
  }
  const closeModal = (): void => {
    setIsShowingWinModal(false)
    setIsCheckWin(false)
    setTimeout(onReCheckWin, 20000)
  }
  const totalPairs = difficulty / 2
  const clearMsg = Data.clearMsg.replace('$totalPairs', `${totalPairs}`)
  const clearTime = `${hoursText}:${minutesText}:${secondsText}`
  const shareMsg = Data.shareMsg
    .replace('$totalPairs', `${totalPairs}`)
    .replace('$clearTime', `${clearTime}`)
  const hashTag = [Data.twitterHashtag]
  const url = window.location.href.replace(history.location.pathname, '')

  return (
    <AlertModal
      isShowing={isShowingWinModal}
      onCloseModal={closeModal}
      title="Congratulations!"
      message={clearMsg}
      clearTime={clearTime}
    >
      <TwitterShareButton url={url} title={shareMsg} hashtags={hashTag}>
        <TwitterButton>
          <FontAwesomeIcon icon={faTwitterSquare} />
        </TwitterButton>
      </TwitterShareButton>
      <SecondaryAction onClick={onGoBack}>Topへ戻る</SecondaryAction>
      <PrimaryAction onClick={onPlayAgain}>もう一回</PrimaryAction>
    </AlertModal>
  )
}

export default GameWinMessage
